/*eslint no-extend-native: ["error", { "exceptions": ["Array"] }]*/
import findIndex from "lodash/findIndex";
Array.prototype.addOrUpdate = function (e, key) {
  const i = findIndex(this, { [key]: e[key] });
  let list = this;
  if (i > -1) {
    list = [...list.slice(0, i), ...list.slice(i + 1)];
  } else {
    list = [...this, e];
  }
  return list;
};

Array.prototype.toggleAll = function (e, key) {
  let list;
  if (this.length === 0) {
    list = e.map((f) => f[key]);
  } else {
    list = [];
  }

  return list;
};
